import { AdminAppState, EventEntry } from '../../state';
import { getEventEntry } from './get-event-entry';

export const getEvent = (eventKey: string) => (
  state: AdminAppState,
): EventEntry['event'] => getEventEntry(eventKey)(state).event;
